import { EventRegistry } from '../shared/events/event_registry';
import { ConfigService } from '../config/config.service';

export class TitleService {
    _baseTitle;
    _titlePrefix;
    _titleSuffix;
    _titleChangedEvent;
    _title;

    constructor() {
        this._baseTitle = ConfigService.imsName;
        this._titlePrefix = '';
        this._titleSuffix = '';
        this._titleChangedEvent = new EventRegistry();
        this._title = this._baseTitle;
    }

    setTitleSuffix(suffix) {
        this._titleSuffix = suffix;
        this._updateTitle();
    }

    _updateTitle() {
        this._title = this._titlePrefix + this._baseTitle + this._titleSuffix;
        this._titleChangedEvent.notifyListeners(this._title);
    }

    addOnTitleChangedListener(listener) {
        return this._titleChangedEvent.addEventListener(listener);
    }
}
